var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatuscross(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.211,
    height: 24.188,
    viewBox: "891.789 737.76 30.211 24.188",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 15988"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129 271s1.486 11.898 9.038 17.945c7.553 6.047 21.173 6.243 21.173 6.243v-21.462S158.2 271 155.959 271H129Z",
    fillRule: "evenodd",
    fill: "url(#a)",
    transform: "translate(762.79 466.76)",
    "data-name": "Path 10949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m906.264 743.549 7.29 7.29",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#fff",
    fill: "transparent",
    "data-name": "Line 30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m913.727 743.549-7.29 7.29",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#fff",
    fill: "transparent",
    "data-name": "Line 31"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0.466,
    x2: 1,
    y2: 0.471,
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff0027",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "red",
    offset: 1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11b700",
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatuscross);
export default __webpack_public_path__ + "static/media/statuscross.494e28f958603b7f09977407a3622ffd.svg";
export { ForwardRef as ReactComponent };